<template>
    <div v-if="params.data">
 <span class="gd-test">{{params.data.testname}}</span>
  <span class="gd-skill">Rounds - {{params.data.requiredskill}}</span>
  <!-- <span class="gd-skill">Optional - {{params.data.optionalskill}}</span> -->
   </div>
</template>